import { render, staticRenderFns } from "./PostFormMentionsLegalesCreate.vue?vue&type=template&id=56d9a69e&scoped=true&"
import script from "./PostFormMentionsLegalesCreate.vue?vue&type=script&lang=js&"
export * from "./PostFormMentionsLegalesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d9a69e",
  null
  
)

export default component.exports